import { BUSINESS_TYPES } from '../supabaseClient';
import { matchPath } from 'react-router-dom';

export const ROUTE_ACCESS = {
  [BUSINESS_TYPES.CLEANING]: [
    '/',
    '/home',
    //'/activity/contacts',
    //'/activity/contacts/:id',
    '/monitor/calls',
    '/monitor/calls/:id',
    '/monitor/texts',
    '/monitor/texts/:id',
    '/monitor/orders',
    '/monitor/tasks',
    // '/train/questions', // Coming soon
    '/train/guides',
    '/train/brain',
    '/train/paths',
    '/train/tools',
    '/train/voice',
    '/train/places',
    '/connect/apps',
    '/connect/apps/curbside',
    '/connect/setup',
    '/connect/alerts',
    '/reports/insights',
    '/account/general',
    // '/account/payment', // Coming soon
    // '/account/billing', // Coming soon
  ],
  [BUSINESS_TYPES.LAUNDROMAT]: [
    '/',
    '/home',
    //'/activity/contacts',
    //'/activity/contacts/:id',
    '/monitor/calls',
    '/monitor/calls/:id',
    '/monitor/texts',
    '/monitor/texts/:id',
    '/monitor/tasks',
    '/monitor/orders',
    // '/train/questions', // Coming soon
    '/train/guides',
    '/train/brain',
    '/train/paths',
    '/train/tools',
    '/train/voice',
    '/train/places',
    '/connect/apps',
    '/connect/apps/curbside',
    '/connect/setup',
    '/connect/alerts',
    '/reports/insights',
    '/account/general',
    // '/account/payment', // Coming soon
    // '/account/billing', // Coming soon
    '/onboarding/business',
    '/admin/knowledge',
  ]
};

// Helper function to check if a route is accessible
export const isRouteAccessible = (businessType, pathname) => {
  // Always allow access to the landing page
  if (pathname === '/') return true;

  if (!businessType || !pathname) return false;

  const allowedRoutes = ROUTE_ACCESS[businessType] || [];

  return allowedRoutes.some((route) => {
    // Create a match pattern object
    const pattern = {
      path: route,
      caseSensitive: false,
      end: true
    };

    // Use matchPath with proper parameters
    return matchPath(pattern, pathname);
  });
};